import { completedStatuses, inProgressStatuses, statuses } from './constants';
import { useOnValueChange } from '../hooks/usePrevious';
import { useDispatch, useSelector } from 'react-redux';
import { addJob } from './store/actions';
import { lastJobOfTypeSelectorFactory } from './store/selectors';
import { Job } from '../../menu/jobsMenu/types';


export const useOnJimJobStatusChange = (
  job: Job,
  callback: (job: Job) => unknown,
  previousStatuses: (Partial<Job>['status'])[] = Object.values(statuses),
  expectedStatuses: Job['status'][] = Object.values(statuses)
) => {
  const jobStatus = job && job.status;

  useOnValueChange(jobStatus, (status, oldStatus) => {
    if (previousStatuses.includes(oldStatus) && expectedStatuses.includes(status)) {
      callback(job);
    }
  });
};

type OnJimStatusChangeCallback = (job: Job) => unknown;

export const useOnJimJobComplete = (job: Job, callback: OnJimStatusChangeCallback) =>
  useOnJimJobStatusChange(job, callback, inProgressStatuses, completedStatuses);

export const useOnJimJobFail = (job: Job, callback: OnJimStatusChangeCallback) =>
  useOnJimJobStatusChange(job, callback, inProgressStatuses, [statuses.Failed]);

export const useOnJimJobSuccess = (job: Job, callback: OnJimStatusChangeCallback) =>
  useOnJimJobStatusChange(job, callback, inProgressStatuses, [statuses.Success]);

export const useGetLastJobOfType = (
  (type: string) => useSelector(lastJobOfTypeSelectorFactory(type))
) as (type: string) => Job | undefined;


export const useAddJob = ({
  jobType,
  onSuccess,
  onError,
}: {
  jobType: string,
  onSuccess?: (job: Job) => unknown,
  onError?: (error: Error) => unknown,
}) => {
  const dispatch = useDispatch();


  return (payload: Record<string, unknown>) => {
    dispatch(
      addJob({
        jobType,
        payload,
        onSuccess,
        onError,
      })
    );
  };
};
